import React from 'react'
import ReactDOM from 'react-dom'

import 'EurestoStyle/main.scss'
import './Utilitaire/Function/Prototype'
import E404 from './App/Static/Error/404'
import { polyfill } from 'es6-promise'
import "moment/min/locales.min"
import 'event-source-polyfill'
import { MuiPickersUtilsProvider } from '@material-ui/pickers'
import MomentUtils from '@date-io/moment'
import CssBaseline from '@material-ui/core/CssBaseline'

polyfill()

// Render Setup
// ------------------------------------

const MOUNT_NODE = document.getElementById('root')

let render = _ => {
  const App = require('./App/Static/App').default
  const routes = require('./App/index').default()

  ReactDOM.render(
    <MuiPickersUtilsProvider utils={MomentUtils}>
      <CssBaseline />
      <App routes={routes} />
    </MuiPickersUtilsProvider>,
    MOUNT_NODE
  )
}

// Development Tools
// ------------------------------------
if (__DEV__) {
  if (module.hot) {
    const renderApp = render
    const renderError = (error) => {
      const RedBox = require('redbox-react').default

      ReactDOM.render(<RedBox error={error} />, MOUNT_NODE)
    }

    render = () => {
      try {
        renderApp()
      } catch (e) {
        renderError(e)
      }
    }

    // Setup hot module replacement
    module.hot.accept([
      './App/Static/App',
      './App/index',
    ], () =>
      setImmediate(() => {
        ReactDOM.unmountComponentAtNode(MOUNT_NODE)
        render()
      })
    )
  }
} else {
  if (module.hot) {
    const renderApp = render
    const renderError = (error) => {
      const RedBox = require('redbox-react').default

      ReactDOM.render(<E404 />, MOUNT_NODE)
    }

    render = () => {
      try {
        renderApp()
      } catch (e) {
        renderError(e)
      }
    }

    // Setup hot module replacement
    module.hot.accept([
      './App/Static/App',
      './App/index',
    ], () =>
      setImmediate(() => {
        ReactDOM.unmountComponentAtNode(MOUNT_NODE)
        render()
      })
    )
  }
}

// Let's Go!
// ------------------------------------
if (!__TEST__) render()



// WEBPACK FOOTER //
// ./app/main.js